module.exports = __webpack_public_path__ + "img/debit.4e9eeb65.svg";